<template>
  <div>
    <TabDescription :text="$t('vp_time_subtext')" :note="$t('vp_data_info')" />
    <SearchView />
  </div>
</template>
<script setup>
import TabDescription from '@/components/visitorsProfile/common/TabDescription.vue'
import SearchView from '@/components/visitorsProfile/searchView/SearchView.vue'
</script>
